import { connect } from 'react-redux'

import { selectAgentsById } from 'selectors/agents/base'

import AgentLinkView from './AgentLinkView'

const select = (state, { value }) => ({
  agent: selectAgentsById(state)[value],
})

export default connect(select)(AgentLinkView)
